import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';
import CommonTitle from '../../../common-components/common-title';

const webpractikTeam = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'руководитель группы разработки',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Алексей Кореньков',
            crewItemSubtitle: 'back-end teamlead',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Пётр Клёнкин',
            crewItemSubtitle: 'старший back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'старший Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Аверкиев',
            crewItemSubtitle: 'back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Гурнак',
            crewItemSubtitle: 'back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Павел Воробьёв',
            crewItemSubtitle: 'старший front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Близнюк',
            crewItemSubtitle: 'front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Константин Кулишов',
            crewItemSubtitle: 'старший DevOps',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Илья Рыбаков',
            crewItemSubtitle: 'QA тестировщик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший дизайнер',
        },
    ],
};

const upgreatTeam = {
    crewTitle: 'Технологические конкурсы Up&nbsp;Great, АО&nbsp;&laquo;РВК&raquo;',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Константин Кайсин',
            crewItemSubtitle: 'операционный директор Up&nbsp;Great, АО&nbsp;&laquo;РВК&raquo;',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Максим Матросов',
            crewItemSubtitle:
                'руководитель направления по&nbsp;техническому сопровождению Up&nbsp;Great, АО&nbsp;&laquo;РВК&raquo;',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Юрий Молодых',
            crewItemSubtitle: 'директор по&nbsp;развитию Up&nbsp;Great, АО&nbsp;&laquo;РВК&raquo;',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мария Ульянова',
            crewItemSubtitle: 'организационный менеджер Up&nbsp;Great, АО&nbsp;&laquo;РВК&raquo;',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <>
                <FullWrapper className="team">
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={webpractikTeam} />
                </FullWrapper>
                <FullWrapper className="team">
                    <CrewContainer container={upgreatTeam} />
                </FullWrapper>
            </>
        );
    }
}

export default Team;
